import { Component } from "react";
import Box from '@mui/material/Box';
import FormHeader from "../../../components/FormHeader";
import RegisterForm from "./form/RegisterForm";

type Props = {};

type State = {
}

export default class Register extends Component<Props, State> {

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <Box>
        <FormHeader title='Solicitar Registro'></FormHeader>
        <RegisterForm></RegisterForm>
      </Box>
    );
  }
}
